import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Viewfinder Realty',
    shortName: 'Viewfinder',
    description: 'Browse California homes for sale by look. Swipe through photos, explore every listing on a map and let Style match find homes like the ones you love.',
    tagline: 'California homes you can picture yourself in.',
    url: getOrigin()
}

export const navLinks = [
    { href: '/homes', label: 'Homes for sale' },
    { href: '/style-match', label: 'Style match' },
    { href: '/saved', label: 'Saved homes' },
    { href: '/sell', label: 'Sell your home' },
    { href: '/agents', label: 'Our agents' }
]
